import React , { useEffect , useMemo} from "react";
import TypeWriter from "react-typewriter";
import useWindowDimensions from '../hooks/useWindowDimensions';
import { ReactP5Wrapper } from "react-p5-wrapper";

const sketch = require(`../sketches/index`).default;

const Header = ({ data }) => {
  const windowDimensions = useWindowDimensions()
  
  if (data) {
    var name = data.name;
    var occupation = data.occupation;
    var description = data.description;
    var networks = data.social.map(function (network) {
      return (
        <li key={network.name}>
          <a href={network.url}>
            <i className={network.className}></i>
          </a>
        </li>
      );
    });
  }
  const canvasRef = React.useRef(0)
  if (document.activeElement === canvasRef.current) {
  }

  const renderCanvas = useMemo(()=>{
    return <ReactP5Wrapper sketch={sketch(windowDimensions.width-15, windowDimensions.height)} canvasRef={canvasRef}/>
  }, [ windowDimensions])

  return (
    <div id="home" style={{
      height:windowDimensions.height,
      width: windowDimensions.width-20
      }} >
       
      <div style={{
        borderRadius: 100,
        margin: '25%',
        padding: 30,
        textAlign: 'center',
        position: 'absolute',
        backgroundColor: 'rgba(20,20,20,0.6)',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
        <div className="row-text" style={{ alignItems: 'center', justifyContent: 'center' }}>
          <h1 style={{
            width: '100%',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#fff',
            font: '3em "opensans-bold", sans-serif'
          }}>
            <TypeWriter typing={1}>{name ? `I'm ${name}.` : null}</TypeWriter>
          </h1>
          <h3 style={{
            font: '18px/1.9em "librebaskerville-regular", serif',
            color: '#fff'
          }}>
            <span style={{ color: '#F06000' }}>{occupation}.</span> {description}.
          </h3>
          <hr />
          <ul className="social">{networks}</ul>
        </div>
      </div> 
      {renderCanvas}
      <p className="scrolldown">
        <a style={{ color: '#F06000' }} className="smoothscroll" href="#about">
          <i className="icon-down-circle"></i>
        </a>
      </p>
    </div>
  )
};

export default Header;
